<!--
 * @Author: ze.wang@diact.com
 * @Date: 2022-11-25 16:19:07
 * @Function: Please Input Function
-->
<template>
  <div class="audio-wrap">
    <audio
      @timeupdate="updateProgress"
      @loadedmetadata="loadedmetadata"
      controls
      ref="audioRef"
      style="display: none"
    >
      <source :src="audioData.url" type="audio/mpeg" />{{ cvtLang('tipsNoSupport', config.tipsNoSupport) }}
    </audio>

    <i
      @click="playAudio"
      class="play-btn"
      :style="{backgroundColor: primaryColor}"
    >
      <img v-if="audioStatus !== 'paused'" :src="require('@/assets/images/edit/config/pause.png')" alt="pause">
      <img v-else :src="require('@/assets/images/edit/config/play.png')" alt="play">
    </i>

    <div class="audio-box">
      <div class="wave-box" ref="waveBox"></div>
      <div class="progress-bar-wrap">
        <el-slider :debounce="0" @change="onChange" v-model="value" :show-tooltip="false"/>
      </div>
      <div class="audio-time" style="min-height: 10px">
        <span class="audio-length-total">{{transTime(duration)}}</span>
      </div>
    </div>

    <i class="el-icon-delete delete-btn" @click="handleRemove(audioData)"></i>
  </div>
</template>

<script>
import Recorder from 'recorder-core';

import 'recorder-core/src/engine/mp3';
import 'recorder-core/src/engine/mp3-engine';

import 'recorder-core/src/extensions/wavesurfer.view';

import axios from 'axios';

export default {
  name: "AudioComponent",
  components: {},
  props: {
    audioData: {
      type: Object,
      default() {
        return {
          url: '',
          length: 0, // 毫秒
          blob: null,
          uid: null
        };
      }
    },
    config: {
      type: Object,
      default: {}
    },
    cvtLang: {
      type: Function,
      defautl: () => {}
    },
    primaryColor: {
      type: String,
      default: '#45BAA3'
    },
  },
  data() {
    return {
      audioStatus: 'paused',

      value: 0,
      duration: 0,
    };
  },
  computed: {},
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      const recordAudio = this.$refs.audioRef;
      recordAudio.muted = true
      recordAudio.play().then(() => recordAudio.pause())
      recordAudio.pause()
      recordAudio.currentTime = 0
    })
  },
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  methods: {
    // 进度条变更
    onChange(val) {
      const recordAudio = this.$refs.audioRef;
      const { paused, currentTime, duration } = recordAudio;
      if (!paused || currentTime !== 0) {
        recordAudio.currentTime = duration * val / 100;
      }
    },
    // 播放暂停控制
    playAudio() {
      const recordAudio = this.$refs.audioRef;
      if (recordAudio.paused) {
        recordAudio.play();
        this.audioStatus = 'playing';
        this.$emit('play', this.audioData)
      } else {
        recordAudio.pause();
        this.audioStatus = 'paused';
      }
    },
    pauseAudio(){
      const recordAudio = this.$refs.audioRef;
      recordAudio.pause();
      this.audioStatus = 'paused';
    },
    // 更新进度条与当前播放时间
    updateProgress(e) {
      const value = e.target.currentTime / this.duration;
      this.value = value * 100;
      if (e.target.currentTime >= this.duration) {
        this.audioStatus = 'paused';
        this.value = 100;
        return;
      }
      this.value = value * 100;
    },
    // 加载完成获取时长
    async loadedmetadata() {
      // console.log('-----loadedmetadata------')
      this.duration = this.$refs.audioRef.duration;
      this.$refs.audioRef.muted = false

      if(!this.audioData.blob){
        const res = await axios.get(this.audioData.url, { responseType: 'blob' });
        this.audioData.blob = res.data
      }
      this.initWave();
    },
    //  音频播放时间格式化
    transTime(value) {
      value = Number(value).toFixed();
      return `${value}s`;
    },
    
    // 初始化音浪
    initWave() {
      const set = {
        elem: this.$refs.waveBox, // 自动显示到dom，并以此dom大小为显示大小
        scale: 2, // 缩放系数，应为正整数，使用2(3? no!)倍宽高进行绘制，避免移动端绘制模糊

        fps: 50, // 绘制帧率，不可过高，50-60fps运动性质动画明显会流畅舒适，实际显示帧率达不到这个值也并无太大影响

        duration: this.duration * 1000, // 当前视图窗口内最大绘制的波形的持续时间，此处决定了移动速率
        direction: -1, // 波形前进方向，取值：1由左往右，-1由右往左
        position: 0, // 绘制位置，取值-1到1，-1为最底下，0为中间，1为最顶上，小数为百分比

        centerHeight: 1, // 中线基础粗细，如果为0不绘制中线，position=±1时应当设为0

        // 波形颜色配置：[位置，css颜色，...] 位置: 取值0.0-1.0之间
        linear: [0, this.primaryColor, 1, this.primaryColor],
        centerColor: '', // 中线css颜色，留空取波形第一个渐变颜色
      };
      this.waveInstance = Recorder.WaveSurferView(set);
      
      this.audioData.blob.arrayBuffer().then(buffer => {
        this.decodeAudio(buffer, ({ sampleRate, data }) => {
          this.waveInstance.draw(data, sampleRate);
        });
      });
    },

    // 音频解码
    decodeAudio(arrayBuffer, True, False) {
      if (!Recorder.Support()) { // 强制激活Recorder.Ctx 不支持大概率也不支持解码
        False && False('浏览器不支持音频解码');
        return;
      }

      const ctx = Recorder.Ctx;
      ctx.decodeAudioData(arrayBuffer, (raw) => {
        const src = raw.getChannelData(0);
        const { sampleRate } = raw;

        const pcm = new Int16Array(src.length);
        for (let i = 0; i < src.length; i++) { // floatTo16BitPCM
          let s = Math.max(-1, Math.min(1, src[i]));
          s = s < 0 ? s * 0x8000 : s * 0x7FFF;
          pcm[i] = s;
        }

        True && True({
          sampleRate,
          duration: Math.round(src.length / sampleRate * 1000),
          data: pcm,
        });
      }, (e) => {
        False && False(`音频解码失败:${e && e.message || '-'}`);
      });
    },

    handleRemove(audioData){
      this.$emit('remove', audioData)
    }

  }
}
</script>
<style lang="scss" scoped>

$waveWrapHeight: 32px;
$waveWrapPaddingTb: 6px;
$waveWrapPaddingLr: 12px;
$playBtnSize: 20px;
$sliderLeft: 40px;
$sliderRight: 45px;

.audio-wrap{
  height: $waveWrapHeight * 2;
  position: relative;
  margin-top: 16px;
  display: flex;
  align-items: center;
  .play-btn{
    display: block;
    min-width: $playBtnSize * 2;
    width: $playBtnSize * 2;
    height: $playBtnSize * 2;
    line-height: 0;
    border-radius: 100%;
    background-color: $color-primary;
    margin-right: 12px;
    &>img{
      width: 100%;
      height: 100%;
    }
  }
  .delete-btn{
    font-size: 32px;
    margin-left: 24px;
    cursor: pointer;
  }
  
  .audio-box{
    flex: 1;
    width: 0;
    height: 100%;
    padding: 0 $waveWrapPaddingLr * 2;
    background: #F5F7FA;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: flex-end;
    .wave-box{
      // height: $playBtnSize * 2;
      position: absolute;
      left: 0;
      right: $sliderRight * 2;
      top: $waveWrapPaddingTb * 2;
      bottom: $waveWrapPaddingTb * 2;
    }
    .progress-bar-wrap{
      position: absolute;
      left: 0;
      right: $sliderRight * 2;
      top: 0;
      bottom: 0;
      >>> {
        .el-slider__runway{
          margin: 0;
          height: $waveWrapHeight * 2;
          background-color: transparent;
          .el-slider__bar{
            height: $waveWrapHeight * 2;
            transition: width 0.25s linear;
            // background-color: rgba($color-primary, 0.2);
          }
          .el-slider__button-wrapper{
            transition: left 0.25s linear;
            height: $waveWrapHeight * 2;
            top: 0;
            .el-slider__button{
              border: 0;
              background-color: transparent;
              position: relative;
              height: 100%;
              &:after,&::after{
                display: inline-block;
                content: ' ';
                height: 100%;
                width: 2px;
                // background-color: $color-primary;
                position: absolute;
                left: 50%;
                top: 0;
              }
            }
          }
        }
      }
    }
    .audio-time{
      .audio-length-total{
        font-weight: 400;
        font-size: 24px;
        line-height: 40px;
        color: #515A6E;
      }
    }
  }
}

.answer-pc{
  .audio-wrap{
    height: $waveWrapHeight * 1;
    position: relative;
    margin-top: 8px;
    display: flex;
    align-items: center;
    .play-btn{
      display: block;
      min-width: $playBtnSize * 1;
      width: $playBtnSize * 1;
      height: $playBtnSize * 1;
      line-height: 0;
      border-radius: 100%;
      background-color: $color-primary;
      margin-right: 12px;
      &>img{
        width: 100%;
        height: 100%;
      }
    }
    .delete-btn{
      font-size: 16px;
      margin-left: 12px;
    }
    
    .audio-box{
      flex: 1;
      width: 0;
      height: 100%;
      padding: 0 $waveWrapPaddingLr * 1;
      background: #F5F7FA;
      border-radius: 4px;
      overflow: hidden;
      display: flex;
      align-items: center;
      position: relative;
      justify-content: flex-end;
      .wave-box{
        // height: $playBtnSize * 1;
        position: absolute;
        left: 0;
        right: $sliderRight * 1;
        top: $waveWrapPaddingTb * 1;
        bottom: $waveWrapPaddingTb * 1;
      }
      .progress-bar-wrap{
        position: absolute;
        left: 0;
        right: $sliderRight * 1;
        top: 0;
        bottom: 0;
        >>> {
          .el-slider__runway{
            margin: 0;
            height: $waveWrapHeight * 1;
            background-color: transparent;
            .el-slider__bar{
              height: $waveWrapHeight * 1;
              transition: width 0.25s linear;
              // background-color: rgba($color-primary, 0.2);
            }
            .el-slider__button-wrapper{
              transition: left 0.25s linear;
              height: $waveWrapHeight * 1;
              top: 0;
              .el-slider__button{
                border: 0;
                background-color: transparent;
                position: relative;
                height: 100%;
                &:after,&::after{
                  display: inline-block;
                  content: ' ';
                  height: 100%;
                  width: 2px;
                  // background-color: $color-primary;
                  position: absolute;
                  left: 50%;
                  top: 0;
                }
              }
            }
          }
        }
      }
      .audio-time{
        .audio-length-total{
          font-weight: 400;
          font-size: 12px;
          line-height: 20px;
          color: #515A6E;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/editor/MusicBox/components/AudioComponent.vue